import { render, staticRenderFns } from "./FormProblemModal.vue?vue&type=template&id=2d07a0aa&scoped=true&"
import script from "./FormProblemModal.vue?vue&type=script&lang=js&"
export * from "./FormProblemModal.vue?vue&type=script&lang=js&"
import style0 from "./FormProblemModal.vue?vue&type=style&index=0&id=2d07a0aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d07a0aa",
  null
  
)

export default component.exports